import React from "react";
import { Button } from "reactstrap";
import { BasicDetailsTypesProfile } from "../../../types/profile";

interface PersonalInfoProps {
  basicDetails: BasicDetailsTypesProfile;
}
const PersonalInfo = ({ basicDetails }: PersonalInfoProps) => {

  return (
    <div className="accordion-body">
      <div className="float-end">
        <Button
          color="none"
          type="button"
          className="btn btn-soft-primary btn-sm"
          onClick={() => alert('Editar')}
        >
          <i className="bx bxs-pencil align-middle"></i>
        </Button>
      </div>

      <div>
        <p className="text-muted mb-1">Empresa</p>
        <h5 className="font-size-14">
          {basicDetails && basicDetails.enterprise ? basicDetails.enterprise : "-"}
        </h5>
        <h5 className="font-size-14">
          {basicDetails && basicDetails.role ? basicDetails.role : ""}
        </h5>
      </div>

      <div>
        <p className="text-muted mb-1">Nome</p>
        <h5 className="font-size-14">{basicDetails && basicDetails.firstName ? basicDetails.firstName : ""}</h5>
      </div>

      <div className="mt-4">
        <p className="text-muted mb-1">E-mail</p>
        <h5 className="font-size-14">
          {basicDetails && basicDetails.email ? basicDetails.email : "-"}
        </h5>
      </div>

      <div className="mt-4">
        <p className="text-muted mb-1">Localização</p>
        <h5 className="font-size-14 mb-0">
          {basicDetails && basicDetails.location ? basicDetails.location : "-"}
        </h5>
      </div>
    </div>
  );
};

export default PersonalInfo;
